module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-precomposed-5ae9eb5c6393d0795c98f81e4460f8e8.png";